import {createRouter, createWebHistory} from "vue-router";
// import vuexStore from "@/core/store";
import store from "@/core/store/PersistentStorage";
// import {Mutations, Actions} from "@/core/store/enums/StoreEnums";
import routes from "@/app/config/routes";
import authService, { TransientRefreshError } from "@/core/services/AuthenticationService";
import { reloadOnNewRelease } from "@/core/router/newRelease";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        ...routes
    ],
    // A hash names an element on the destination page -- #assignment-3026 on a share link --
    // and that element does not exist yet: the page that owns it renders the list once its
    // API call resolves, and scrolls to the element itself at that point. Scrolling here
    // would either find nothing or, worse, race the page's own scroll and win, leaving the
    // student at the top of a page whose highlighted assignment is somewhere below the fold.
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return false
        }
        return savedPosition || { top: 0 }
    }
});

router.beforeEach(async (to, from) => {
    // reset config to initial state
    // vuexStore.commit(Mutations.RESET_LAYOUT_CONFIG);

    // Redirect to home when going to login page when already logged in
    if (to.name === 'login' && store.authentication.user) {
        router.push({ name: 'home' })
    }
});

router.beforeResolve(async to => {
    // Validate session for pages that are not public.
    if(to.meta.private) {
        // A TransientRefreshError here means the refresh server failed transiently;
        // we let navigation continue and let downstream API calls retry.
        try {
            await authService.validateSession();
        } catch (err) {
            if (!(err instanceof TransientRefreshError)) {
                console.error('Unexpected error in route guard:', err);
            }
        }
        const features = store.authentication.features || [];
        if (authService.currentUser()?.currentInstance) {
            if (to.name === 'assignments' && !features.includes('arcreads-assignments') && store.authentication.featuresLoaded) return '/';
            if (to.name === 'logbook' && !features.includes('arcreads-logbook') &&  store.authentication.featuresLoaded) return '/';
            if (to.name === 'myirla' && !features.includes('arcreads-myirla') && store.authentication.featuresLoaded) return '/';
        }
    }
});

reloadOnNewRelease(router);

export default router;
